module.exports = __webpack_public_path__ + "static/media/14.7440786c.jpeg";